/**
 * Created by ganlu on 25/09/2016.
 */
class MessageService {
    constructor($timeout) {
        "ngInject";
        this.$timeout = $timeout;
    }

    success(message) {
        this.clear();
        $('.gather-modal-tip').addClass('success');
        this.show(message, 3000);
    }

    error(message, period) {
        this.clear();
        $('.gather-modal-tip').addClass('error');

        let p = typeof(period) == 'undefined' ? 3000 : period;

        this.show(message, p);
    }

    info(message) {
        this.clear();
        $('.gather-modal-tip').addClass('info');
        this.show(message, 0);
    }
    warn(message, period) {
        this.clear();
        $('#alert-message').addClass('warn');

        let p = typeof(period) == 'undefined' ? 3000 : period;

        this.show(message, p);
    }
    clear() {
        $('.gather-modal-tip')
            .removeClass('error')
            .removeClass('success')
            .removeClass('info');
    }

    show(message, period) {

        $('.gather-modal-tip').html(message).show();

        if (period != 0) {
            this.$timeout(
                () => {
                    $('.gather-modal-tip').hide();
                },
                period
            );
        }
    }

    hide() {
        $('.gather-modal-tip').hide();
    }
}

export default MessageService;



// WEBPACK FOOTER //
// ./src/app/components/page/original/original-article/gather-box/message.service.js